import * as React from 'react';
import b from 'b_';
import { IdeaTopCardFragment } from '../../__generated__/IdeaTopCardFragment';
import { Fees } from './components/Fees';
import { Buttons } from './components/Buttons';
import { Properties } from './components/Properties';

import './index.scss';

interface Props {
  idea: IdeaTopCardFragment;
  isIdeaLandingCard?: boolean;
}

export const Footer: React.FC<Props> = ({ idea, isIdeaLandingCard }) => (
  <div className={b('idea-top-card-footer')}>
    <Properties idea={idea} />
    {!isIdeaLandingCard ? <Buttons idea={idea} /> : <Fees idea={idea} />}
  </div>
);
